module.exports = __webpack_public_path__ + "media/claim/assets/images/checkmark-40c4466610d9652fcb0410b18e88b116.png";